import React from 'react';
import { Box, Button } from '@nimbus-ds/components';
import { EmptyMessage } from '@nimbus-ds/patterns';
import { CheckCircleIcon, ExclamationCircleIcon } from '@tiendanube/icons';
import { useNavegate } from 'App/hooks';
import useTranslationOrders from '../../../../../useTranslationOrders';

interface Attributes {
  orderId: string;
  isRefunded: boolean;
}

function RefundUnavailableMessage({
  orderId,
  isRefunded,
}: Attributes): React.JSX.Element {
  const translate = useTranslationOrders();
  const t = (key: string) =>
    isRefunded
      ? translate(`refund.unavailable.alreadyRefunded.${key}`)
      : translate(`refund.unavailable.notAllowed.${key}`);

  const { goTo } = useNavegate();
  const goToOrderDetails = () => goTo(`/orders/${orderId}`);

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="45vh"
      justifyContent="center"
    >
      <EmptyMessage
        title={t('title')}
        text={t('description')}
        icon={
          isRefunded ? (
            <CheckCircleIcon size={32} />
          ) : (
            <ExclamationCircleIcon size={32} />
          )
        }
        actions={
          <Button appearance="primary" onClick={goToOrderDetails}>
            {t('action')}
          </Button>
        }
      />
    </Box>
  );
}

export default RefundUnavailableMessage;
